import thunk from 'redux-thunk'
import epic from './epic'
import { routerMiddleware } from 'react-router-redux'

export default (history) => [
  thunk,
  epic,
  routerMiddleware(history),
]



// WEBPACK FOOTER //
// ./src/scripts/store/middleware/index.js